export default __webpack_public_path__ + "static/media/udemy1.efbb009e.jpeg";